import React, { useState, useEffect } from 'react';

const WhatsAppLogsContent = () => {
  const [logs, setLogs] = useState([]);
  const [filteredLogs, setFilteredLogs] = useState([]);
  const [activeTab, setActiveTab] = useState('all');
  const [selectedPeriod, setSelectedPeriod] = useState('daily');
  const [searchPhone, setSearchPhone] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [stats, setStats] = useState({
    total: 0,
    successful: 0,
    failed: 0,
    pending: 0
  });

  const firmSlug = sessionStorage.getItem('firmSlug');

  useEffect(() => {
    if (firmSlug) {
      loadLogs();
    }
  }, [firmSlug]);

  useEffect(() => {
    // Logs yüklendikten sonra veya filtreler değiştiğinde filtrele
    if (logs.length > 0) {
      filterLogs();
    }
  }, [logs, activeTab, selectedPeriod, searchPhone]);

  const loadLogs = async () => {
    try {
      setLoading(true);
      setError(null);

      // İlk yüklemede son 20 mesaj
      const response = await fetch(`https://panel.fbajans.com/api/firms/${firmSlug}/logs?limit=500`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      // Backend bazı sürümlerde {success, data: {logs, stats}} döndürüyor
      const newLogs = (data && data.data && data.data.logs) || data.logs || [];
      setLogs(newLogs);
      calculateStats(newLogs);
      // useEffect ile otomatik filtreleme yapılacak
    } catch (err) {
      console.error('WhatsApp logları yüklenirken hata:', err);
      setError('Loglar yüklenirken hata oluştu: ' + err.message);
    } finally {
      setLoading(false);
    }
  };


  const calculateStats = (logData) => {
    const stats = {
      total: logData.length,
      successful: logData.filter(log => log.status === 'sent').length,
      failed: logData.filter(log => log.status === 'failed').length,
      pending: logData.filter(log => log.status === 'pending').length
    };
    setStats(stats);
  };

  const calculateFilteredStats = () => {
    let filtered = [...logs];

    // ÖNCE zaman filtresi uygula (en önemli filtre)
    const now = new Date();
    if (selectedPeriod === 'daily') {
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      filtered = filtered.filter(log => new Date(log.created_at) >= today);
    } else if (selectedPeriod === 'weekly') {
      const weekAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
      filtered = filtered.filter(log => new Date(log.created_at) >= weekAgo);
    }

    // Telefon filtresi uygula (tab filtresi YOK - istatistikler için)
    if (searchPhone.trim()) {
      filtered = filtered.filter(log => 
        log.phone && log.phone.includes(searchPhone.trim())
      );
    }

    return {
      total: filtered.length,
      successful: filtered.filter(log => log.status === 'sent').length,
      failed: filtered.filter(log => log.status === 'failed').length,
      pending: filtered.filter(log => log.status === 'pending').length
    };
  };

  const filterLogs = () => {
    let filtered = [...logs];

    // ÖNCE zaman filtresi uygula (en önemli filtre)
    const now = new Date();
    if (selectedPeriod === 'daily') {
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      filtered = filtered.filter(log => new Date(log.created_at) >= today);
      console.log('📅 Daily filter applied, remaining logs:', filtered.length);
    } else if (selectedPeriod === 'weekly') {
      const weekAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
      filtered = filtered.filter(log => new Date(log.created_at) >= weekAgo);
      console.log('📅 Weekly filter applied, remaining logs:', filtered.length);
    }

    // SONRA tab filtresi uygula
    if (activeTab === 'successful') {
      filtered = filtered.filter(log => log.status === 'sent');
      console.log('✅ Success filter applied, remaining logs:', filtered.length);
    } else if (activeTab === 'failed') {
      filtered = filtered.filter(log => log.status === 'failed');
      console.log('❌ Failed filter applied, remaining logs:', filtered.length);
    }

    // SON OLARAK telefon numarası arama
    if (searchPhone.trim()) {
      filtered = filtered.filter(log => 
        log.phone && log.phone.includes(searchPhone.trim())
      );
      console.log('📱 Phone filter applied, remaining logs:', filtered.length);
    }

    console.log('🔍 Final filtered logs:', filtered.length, 'from', logs.length, 'total logs');
    console.log('🔍 Active tab:', activeTab, 'Selected period:', selectedPeriod);
    setFilteredLogs(filtered);
  };

  const getStatusBadge = (status) => {
    const statusConfig = {
      'sent': { class: 'status-success', text: 'Başarılı', icon: 'fas fa-check-circle' },
      'failed': { class: 'status-failed', text: 'Başarısız', icon: 'fas fa-times-circle' },
      'pending': { class: 'status-pending', text: 'Bekliyor', icon: 'fas fa-clock' },
      'processing': { class: 'status-processing', text: 'İşleniyor', icon: 'fas fa-spinner' }
    };

    const config = statusConfig[status] || { class: 'status-unknown', text: status, icon: 'fas fa-question-circle' };

    return (
      <span style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        padding: '4px 8px',
        borderRadius: '12px',
        fontSize: '12px',
        fontWeight: '600',
        border: '2px solid',
        ...(config.class === 'status-success' && {
          background: 'rgba(37, 211, 102, 0.1)',
          color: '#25d366',
          borderColor: '#25d366'
        }),
        ...(config.class === 'status-failed' && {
          background: 'rgba(255, 71, 87, 0.1)',
          color: '#ff4757',
          borderColor: '#ff4757'
        }),
        ...(config.class === 'status-pending' && {
          background: 'rgba(255, 165, 2, 0.1)',
          color: '#ffa502',
          borderColor: '#ffa502'
        })
      }}>
        <i className={config.icon} style={{ marginRight: '4px' }}></i>
        {config.text}
      </span>
    );
  };

  // Küçük ikon (metinsiz) gösterimi
  const getStatusIcon = (status) => {
    const map = {
      'sent': { color: '#28a745', icon: 'fas fa-check-circle', title: 'Başarılı' },
      'failed': { color: '#dc3545', icon: 'fas fa-times-circle', title: 'Başarısız' },
      'pending': { color: '#ffc107', icon: 'fas fa-clock', title: 'Bekliyor' },
      'processing': { color: '#17a2b8', icon: 'fas fa-spinner', title: 'İşleniyor' }
    };
    const cfg = map[status] || { color: '#6c757d', icon: 'fas fa-question-circle', title: status };
    return (
      <i className={cfg.icon} title={cfg.title} style={{ color: cfg.color, fontSize: '14px' }} />
    );
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    const now = new Date();
    const diff = now - date;
    
    // Son 24 saat içindeyse
    if (diff < 24 * 60 * 60 * 1000) {
      const hours = Math.floor(diff / (60 * 60 * 1000));
      const minutes = Math.floor((diff % (60 * 60 * 1000)) / (60 * 1000));
      
      if (hours > 0) {
        return `${hours} saat önce`;
      } else if (minutes > 0) {
        return `${minutes} dakika önce`;
      } else {
        return 'Az önce';
      }
    }
    
    return date.toLocaleString('tr-TR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const formatPhone = (phone) => {
    if (!phone) return '-';
    // Tam numarayı göster
    return phone;
  };

  const formatMessage = (message) => {
    if (!message) return '-';
    return message;
  };

  const clearFilters = () => {
    setSearchPhone('');
    setSelectedPeriod('daily');
    setActiveTab('all');
  };

  if (loading && logs.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: '40px' }}>
        <div style={{ 
          width: '40px', 
          height: '40px', 
          border: '4px solid #f3f3f3',
          borderTop: '4px solid #25d366',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          margin: '0 auto 16px'
        }}></div>
        <p>WhatsApp logları yükleniyor...</p>
      </div>
    );
  }

  return (
    <div>
      {/* İstatistik Kartları */}
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', 
        gap: '16px', 
        marginBottom: '24px' 
      }}>
        {(() => {
          const filteredStats = calculateFilteredStats();
          return (
            <>
              <div style={{ 
                background: 'linear-gradient(135deg, #667eea, #764ba2)', 
                color: 'white',
                padding: '20px', 
                borderRadius: '12px', 
                textAlign: 'center' 
              }}>
                <div style={{ fontSize: '24px', fontWeight: 'bold' }}>{filteredStats.total}</div>
                <div style={{ fontSize: '14px', opacity: 0.8 }}>Toplam</div>
              </div>
              
              <div style={{ 
                background: 'linear-gradient(135deg, #25d366, #128c7e)', 
                color: 'white',
                padding: '20px', 
                borderRadius: '12px', 
                textAlign: 'center' 
              }}>
                <div style={{ fontSize: '24px', fontWeight: 'bold' }}>{filteredStats.successful}</div>
                <div style={{ fontSize: '14px', opacity: 0.8 }}>Başarılı</div>
              </div>
              
              <div style={{ 
                background: 'linear-gradient(135deg, #ff4757, #ff3838)', 
                color: 'white',
                padding: '20px', 
                borderRadius: '12px', 
                textAlign: 'center' 
              }}>
                <div style={{ fontSize: '24px', fontWeight: 'bold' }}>{filteredStats.failed}</div>
                <div style={{ fontSize: '14px', opacity: 0.8 }}>Başarısız</div>
              </div>
              
              <div style={{ 
                background: 'linear-gradient(135deg, #ffa502, #ff6348)', 
                color: 'white',
                padding: '20px', 
                borderRadius: '12px', 
                textAlign: 'center' 
              }}>
                <div style={{ fontSize: '24px', fontWeight: 'bold' }}>{filteredStats.pending}</div>
                <div style={{ fontSize: '14px', opacity: 0.8 }}>Bekliyor</div>
              </div>
            </>
          );
        })()}
      </div>

      {/* Filtreler ve Sekmeler */}
      <div style={{ marginBottom: '20px' }}>
        <div style={{ 
          display: 'flex', 
          gap: '8px', 
          marginBottom: '16px',
          background: '#f8f9fa',
          borderRadius: '8px',
          padding: '4px'
        }}>
          <button 
            style={{
              flex: 1,
              background: activeTab === 'all' ? 'linear-gradient(135deg, #667eea, #764ba2)' : 'transparent',
              color: activeTab === 'all' ? 'white' : '#666',
              border: 'none',
              borderRadius: '6px',
              padding: '8px 12px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '600'
            }}
            onClick={() => setActiveTab('all')}
          >
            Tümü ({calculateFilteredStats().total})
          </button>
          
          <button 
            style={{
              flex: 1,
              background: activeTab === 'successful' ? 'linear-gradient(135deg, #25d366, #128c7e)' : 'transparent',
              color: activeTab === 'successful' ? 'white' : '#666',
              border: 'none',
              borderRadius: '6px',
              padding: '8px 12px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '600'
            }}
            onClick={() => setActiveTab('successful')}
          >
            Başarılı ({calculateFilteredStats().successful})
          </button>
          
          <button 
            style={{
              flex: 1,
              background: activeTab === 'failed' ? 'linear-gradient(135deg, #ff4757, #ff3838)' : 'transparent',
              color: activeTab === 'failed' ? 'white' : '#666',
              border: 'none',
              borderRadius: '6px',
              padding: '8px 12px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '600'
            }}
            onClick={() => setActiveTab('failed')}
          >
            Başarısız ({calculateFilteredStats().failed})
          </button>
        </div>

        <div style={{ display: 'flex', gap: '16px', alignItems: 'end', flexWrap: 'wrap' }}>
          <div style={{ flex: 1, minWidth: '200px' }}>
            <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: '#333', marginBottom: '8px' }}>
              <i className="fas fa-mobile-alt" style={{ marginRight: '8px' }}></i>
              Telefon Numarası
            </label>
            <input
              type="text"
              style={{
                width: '100%',
                padding: '8px 12px',
                border: '2px solid #e9ecef',
                borderRadius: '6px',
              fontSize: '14px',
              boxSizing: 'border-box'
              }}
              placeholder="Telefon numarası ara..."
              value={searchPhone}
              onChange={(e) => setSearchPhone(e.target.value)}
            />
          </div>

          <div style={{ flex: 1, minWidth: '150px' }}>
            <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: '#333', marginBottom: '8px' }}>
              📅 Zaman Aralığı
            </label>
            <select
              style={{
                width: '100%',
                padding: '8px 12px',
                border: '2px solid #e9ecef',
                borderRadius: '6px',
              fontSize: '14px',
              boxSizing: 'border-box'
              }}
              value={selectedPeriod}
              onChange={(e) => setSelectedPeriod(e.target.value)}
            >
              <option value="daily">Bugün</option>
              <option value="weekly">Son 7 Gün</option>
              <option value="all">Tümü</option>
            </select>
          </div>

          <button 
            onClick={clearFilters}
            style={{
              background: '#6c757d',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              padding: '8px 12px',
              fontSize: '14px',
              fontWeight: '600',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
          >
            <i className="fas fa-trash-alt" style={{ marginRight: '8px' }}></i>
            Filtreleri Temizle
          </button>
        </div>
      </div>

      {/* Log Tablosu */}
      <div>
        {error && (
          <div style={{ 
            background: 'rgba(255, 71, 87, 0.1)',
            border: '1px solid #ff4757',
            borderRadius: '8px',
            padding: '12px',
            margin: '16px 0',
            color: '#ff4757',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
            <i className="fas fa-exclamation-triangle" style={{ marginRight: '8px' }}></i>
            {error}
          </div>
        )}

        {filteredLogs.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>📭</div>
            <h3>Log Bulunamadı</h3>
            <p>
              {searchPhone || selectedPeriod !== 'all' || activeTab !== 'all' 
                ? 'Arama kriterlerinize uygun log bulunamadı.' 
                : 'Henüz WhatsApp mesajı bulunmuyor.'}
            </p>
            {(searchPhone || selectedPeriod !== 'all' || activeTab !== 'all') && (
              <button 
                onClick={clearFilters}
                style={{
                  background: '#6c757d',
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  padding: '8px 16px',
                  cursor: 'pointer',
                  marginTop: '16px'
                }}
              >
                Filtreleri Temizle
              </button>
            )}
          </div>
        ) : (
          <div style={{ 
            maxHeight: '500px', 
            overflowY: 'auto',
            border: '1px solid #e9ecef',
            borderRadius: '8px'
          }}>
            {filteredLogs.map((log, index) => (
              <div key={log.id} style={{
                borderBottom: '1px solid #f1f3f4',
                padding: '16px',
                transition: 'all 0.3s ease'
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <span style={{ fontFamily: 'monospace', fontSize: '12px', color: '#666' }}>#{log.id}</span>
                    <span style={{ fontFamily: 'monospace', fontSize: '14px', fontWeight: '600' }}>{formatPhone(log.phone)}</span>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                    <div style={{ fontSize: '12px', color: '#666' }}>{formatDate(log.created_at)}</div>
                    <div style={{ marginTop: '4px' }}>{getStatusIcon(log.status)}</div>
                  </div>
                </div>
                
                <div style={{ marginBottom: '8px', fontSize: '14px', color: '#333', whiteSpace: 'pre-wrap' }}>
                  {formatMessage(log.message)}
                </div>
                
                {/* Alt satırdaki durum rozeti kaldırıldı; üstte tarih altına küçük ikon gösteriliyor */}
              </div>
            ))}
          </div>
        )}
      </div>


      <style jsx>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default WhatsAppLogsContent;
